import { useNavigate } from 'react-router-dom'
import { X, LogIn, Star } from 'lucide-react'
import { useDialog } from '../hooks/useDialog'
import { Button } from './UI'

export function AuthModal({ onClose }) {
  const navigate = useNavigate()
  const dialogRef = useDialog(onClose)

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 'var(--z-auth)',
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '20px',
    }} onClick={onClose}>
      <div ref={dialogRef} role="dialog" aria-modal="true" aria-label="Sign in to track shows" style={{
        background: 'var(--sheet)',
        border: '1px solid var(--border)',
        borderRadius: '24px',
        padding: '32px 28px',
        maxWidth: '360px', width: '100%',
        textAlign: 'center', position: 'relative',   // anchor the absolute ✕ to the card, not the viewport
        boxShadow: '0 24px 64px rgba(0,0,0,0.6)',
      }} onClick={e => e.stopPropagation()}>
        <button className="ui-hit" onClick={onClose} aria-label="Close" style={{
          position: 'absolute', top: '16px', right: '16px',
          background: 'var(--surface)', border: 'none',
          borderRadius:'var(--radius-full)', width: '32px', height: '32px',
          color: 'var(--text-strong)', cursor: 'pointer', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
        }}>
          <X size={16} />
        </button>

        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📺</div>
        <h2 style={{ color: 'var(--text-strong)', margin: '0 0 8px', fontSize: '22px', fontWeight: 600 }}>
          Sign in to track shows
        </h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '14px', margin: '0 0 24px', lineHeight: 1.5 }}>
          Create a free account to save your watchlist, get episode reminders, and earn achievements.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <Button variant="primary" onClick={() => { navigate('/login'); onClose() }} style={{ width: '100%' }}>
            <LogIn size={18} /> Sign in / Create account
          </Button>
          <Button variant="secondary" onClick={onClose} style={{ width: '100%' }}>
            Continue browsing
          </Button>
        </div>

        <div style={{
          marginTop: '24px', padding: '12px 16px',
          background: 'rgba(255,200,60,0.08)', borderRadius:'var(--radius-sm)',
          border: '1px solid rgba(255,200,60,0.15)',
          display: 'flex', alignItems: 'center', gap: '8px',
          color: 'rgba(255,200,60,0.9)', fontSize: '13px',
        }}>
          <Star size={14} fill="currentColor" />
          <span>Earn achievements as you track!</span>
        </div>
      </div>
    </div>
  )
}
